// Module
var code = "<span class=\"note-type-badge\" ng-if=\"::vm.displayNoteType\"> {{ vm.noteType }} </span> ";
// Exports
module.exports = code;